import { Component } from 'preact'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import ParentCategory from './ParentCategory'

const SortableList = SortableContainer(({ children }) => children)
const SortableItem = SortableElement(({ children }) => children)

class CategoryManager extends Component {
  onCategorySorted (newList, idx) {
    let categoryList = [].concat(this.props.categories)
    categoryList[idx].children = newList
    this.props.updateCategoriesOrder(categoryList)
  }

  onParentCategorySorted ({ oldIndex, newIndex }) {
    let categoryList = [].concat(this.props.categories)
    this.props.updateCategoriesOrder(arrayMove(categoryList, oldIndex, newIndex))
  }

  render (props, state) {
    const categories = props.categories

    return (
      <div>
        <SortableList
          useDragHandle
          onSortEnd={(prev, next) => this.onParentCategorySorted(prev, next)}
          lockToContainerEdges
          lockAxis='y'
          axis='y'
          useWindowAsScrollContainer>
          <div className='category-manager_parent-category-container'>
            {
              categories.map((parentCategory, idx) => (
                <SortableItem index={idx} key={parentCategory.id}>
                  <ParentCategory
                    addCategoryLink={props.addCategoryLink}
                    editCategoryLink={props.editCategoryLink}
                    idx={idx}
                    parentCategory={parentCategory}
                    onCategorySorted={(newList, idx) => this.onCategorySorted(newList, idx)}
                  />
                </SortableItem>)
              )
            }
          </div>
        </SortableList>
      </div>
    )
  }
}

export default CategoryManager
